import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { register } from '../../api/services/authService';
import { emailError, lengthError, nameError, passwordError } from '../../utils/validation';
import AuthLayout from './AuthLayout';
import { AuthField, PasswordField } from './AuthField';

export default function Signup() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [company, setCompany] = useState('');
  const [inviteCode, setInviteCode] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    const problem = nameError(name, { label: 'Full name' }) || emailError(email) || lengthError(company, { max: 80, label: 'Company name' })
      || (inviteCode.trim() && !/^\d{6}$/.test(inviteCode.trim()) ? 'Invite code is 6 digits.' : '') || passwordError(password);
    if (problem) return setError(problem);
    if (password !== confirmPassword) return setError('Passwords do not match');
    setLoading(true);
    try {
      const result = await register({
        name: name.trim(), email: email.trim(), password,
        companyName: company.trim(), inviteCode: inviteCode.trim()
      });
      if (result.verificationRequired) {
        navigate('/verify-email', { state: { email: result.email, demoCode: result.demoCode } });
      } else {
        navigate('/login', { state: { registered: true, joined: result.joined } });
      }
    } catch (err) {
      const fields = err.details?.fields || {};
      setError(fields.inviteCode || fields.email || fields.password || fields.name || err.message || 'Unable to create the account.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Create Account"
      subtitle="Sign up to get started"
      footer={<>Already have an account? <Link to="/login">Sign in</Link></>}
    >
      <form onSubmit={handleSubmit} noValidate>
        <AuthField label="Full name" icon="bi-person" value={name} onChange={e => setName(e.target.value)} placeholder="Full Name" autoComplete="name" />
        <AuthField label="Email address" icon="bi-envelope" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Email Address" autoComplete="email" />
        <AuthField label="Company name (optional)" icon="bi-building" value={company} onChange={e => setCompany(e.target.value)} placeholder="Company name (optional)" autoComplete="organization" />
        <AuthField label="Invite code (optional)" icon="bi-key" value={inviteCode} onChange={e => setInviteCode(e.target.value)} placeholder="Invite code (optional)" inputMode="numeric" />
        <p className="auth-hint">A company name creates your own workspace. An invite code joins the workspace you were invited to.</p>
        <PasswordField label="Password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Password (8+ characters)" autoComplete="new-password" />
        <PasswordField label="Confirm password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} placeholder="Confirm Password" autoComplete="new-password" />
        {error && <div className="auth-error" role="alert">{error}</div>}
        <button className="auth-primary" type="submit" disabled={loading}>{loading ? 'Creating…' : 'Create Account'}</button>
      </form>
    </AuthLayout>
  );
}
